import { createContext } from "react";
export const ReportContext = createContext({
    routerRootPath: "/",
    reportId: "",
    diffId: "",
    roles: {
        canExportCve: false,
        canExportCycloneDx: false,
        canExportJson: false,
        canExportSafe: false,
        canExportSarif: false,
        canExportSpdx: false,
        canExportSummaryPdf: false,
        canExportUri: false,
        canDownloadPackage: false,
    },
    activeExport: {
        cve: false,
        cycloneDX: false,
        json: false,
        safe: false,
        sarif: false,
        spdx: false,
        summaryPdf: false,
        uri: false,
    },
    supportsYaraPolicies: true,
    selectedCheck: "scan-version",
});
//# sourceMappingURL=index.js.map